import axiosInstance from '../config/axiosInstance';
import { API_ENDPOINTS } from '../constants/apiEndpoints';

export const getAdminRecruitmentJobTypes = async (params = {}) => {
    if (!params.languageCode) params.languageCode = 'vi';
    if (!params.pageSize) params.pageSize = 1000;
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_JOB_TYPES.GET_ALL, { params });
    return response.data;
};

export const getAdminRecruitmentJobTypeById = async (id) => {
    const response = await axiosInstance.get(API_ENDPOINTS.ADMIN.RECRUITMENT_JOB_TYPES.GET_BY_ID(id));
    return response.data;
};

export const createRecruitmentJobType = async (data) => {
    const response = await axiosInstance.post(API_ENDPOINTS.ADMIN.RECRUITMENT_JOB_TYPES.CREATE, data);
    return response.data;
};

export const updateRecruitmentJobType = async (id, data) => {
    const response = await axiosInstance.put(API_ENDPOINTS.ADMIN.RECRUITMENT_JOB_TYPES.UPDATE(id), data);
    return response.data;
};

export const deleteRecruitmentJobType = async (id) => {
    const response = await axiosInstance.delete(API_ENDPOINTS.ADMIN.RECRUITMENT_JOB_TYPES.DELETE(id));
    return response.data;
};
